import { useSearchParams } from 'react-router';
import useNumberParameter from './use-number-parameter';
import { siteConfig } from '@/app/config/global';

const useRowsPerPage = (): number => {
  const [searchParameters] = useSearchParams();
  return useNumberParameter({
    searchParams: searchParameters,
    key: 'rowsPerPage',
    fallback: siteConfig.rowsPerPageDefault,
  });
};

export default useRowsPerPage;
